import { render, staticRenderFns } from "./ApmsRegPlantProtectionInfoDetail.vue?vue&type=template&id=247a3ef2&scoped=true&"
import script from "./ApmsRegPlantProtectionInfoDetail.vue?vue&type=script&lang=js&"
export * from "./ApmsRegPlantProtectionInfoDetail.vue?vue&type=script&lang=js&"
import style0 from "./ApmsRegPlantProtectionInfoDetail.vue?vue&type=style&index=0&id=247a3ef2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247a3ef2",
  null
  
)

export default component.exports